import { FC, Suspense, useState } from 'react';
import ProgressStudentTablesHeader from './ProgressStudentTablesHeader';
import ProgressStudentSnapshotTable from './ProgressTables/ProgressStudentSnapshotTable';
import ProgressStudentGrowthTable from './ProgressTables/ProgressStudentGrowthTable';
import ProgressStudentRoadmapProgressTable from './ProgressTables/ProgressStudentRoadmapProgressTable';
import { useQueryLoader } from 'react-relay';
import { getStudentGrowthAndEngagement, getStudentRoadmapByGrade } from '../../graphQLOperations/Progress';
import { ProgressStudentsRoadmapByGradeQuery } from '../../graphQLOperations/__generated__/ProgressStudentsRoadmapByGradeQuery.graphql';
import { ProgressStudentsGrowthAndEngagementQuery } from '../../graphQLOperations/__generated__/ProgressStudentsGrowthAndEngagementQuery.graphql';
import { ThreeDotLoader } from '../Fallback/ThreeDotsLoader';

export enum ProgressStudentSelector {
  SNAPSHOT = 0,
  GROWTH_AND_ENGAGEMENT = 1,
  ROADMAP_PROGRESS_BY_GRADE = 2,
}

const ProgressStudentTablesContainer: FC = () => {
  const [headerSelector, setHeaderSelector] = useState<ProgressStudentSelector>(ProgressStudentSelector.SNAPSHOT);
  const [roadmapQueryRef, loadRoadmapQuery] =
    useQueryLoader<ProgressStudentsRoadmapByGradeQuery>(getStudentRoadmapByGrade);
  const [growthQueryRef, loadGrowthQuery] =
    useQueryLoader<ProgressStudentsGrowthAndEngagementQuery>(getStudentGrowthAndEngagement);
  return (
    <>
      <Suspense fallback={<ThreeDotLoader />}>
        <ProgressStudentTablesHeader
          headerSelector={headerSelector}
          setHeaderSelector={setHeaderSelector}
          loadRoadmapQuery={loadRoadmapQuery}
          loadGrowthQuery={loadGrowthQuery}
        />
      </Suspense>
      {headerSelector === ProgressStudentSelector.SNAPSHOT && <ProgressStudentSnapshotTable />}
      {headerSelector === ProgressStudentSelector.GROWTH_AND_ENGAGEMENT && (
        <ProgressStudentGrowthTable growthQueryRef={growthQueryRef} />
      )}
      {headerSelector === ProgressStudentSelector.ROADMAP_PROGRESS_BY_GRADE && (
        <ProgressStudentRoadmapProgressTable roadmapQueryRef={roadmapQueryRef} />
      )}
    </>
  );
};

export default ProgressStudentTablesContainer;
